// Import Symbol.observable polyfill before any Redux imports
import './symbol-observable-polyfill'

import get from 'lodash/get'

// Set webpack public path from environment variable
if (process.env.WEBPACK_PUBLIC_PATH) {
  // eslint-disable-next-line camelcase, no-undef
  __webpack_public_path__ = process.env.WEBPACK_PUBLIC_PATH
}

window.addEventListener('unhandledrejection', (e) => {
  e.preventDefault()
  const detailReason = get(e, 'detail.reason')
  const reason = get(e, 'reason')
  console.error(detailReason || reason || 'Unknown reason in unhandledrejection') // eslint-disable-line no-console
})
